import { createContext } from 'use-context-selector';
import { createProvider } from 'domain/createProvider';
import { TUpdate } from 'domain/types';

export type TCreateJobPostContextState = {
  createJobPostData: any;
  isOpenBackToHomeModal: boolean;
  isOpenAfterSubmitJobPostModal: boolean;
  isOpenAddQuestionModal: boolean;
  isOpenJobSeekerApplyForJobPostModal: boolean;
  screeningQuestions: any;
  editingQuestionId: number | null;
  update?: TUpdate<TCreateJobPostContextState>;
};

const initState: TCreateJobPostContextState = {
  createJobPostData: {},
  isOpenBackToHomeModal: false,
  isOpenAfterSubmitJobPostModal: false,
  isOpenAddQuestionModal: false,
  isOpenJobSeekerApplyForJobPostModal: false,
  screeningQuestions: [],
  editingQuestionId: null,
};

export const CreateJobPostConfigContext = createContext<TCreateJobPostContextState>(initState);

export const CreateJobPostProvider = createProvider(CreateJobPostConfigContext, initState);
